var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_708_1632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0057 6.66929C14.0057 11.3378 8.00334 15.3394 8.00334 15.3394C8.00334 15.3394 2.00098 11.3378 2.00098 6.66929C2.00098 5.07737 2.63337 3.55064 3.75903 2.42498C4.88469 1.29932 6.41141 0.666931 8.00334 0.666931C9.59527 0.666931 11.122 1.29932 12.2477 2.42498C13.3733 3.55064 14.0057 5.07737 14.0057 6.66929Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00323 8.67008C9.10823 8.67008 10.004 7.7743 10.004 6.66929C10.004 5.56429 9.10823 4.6685 8.00323 4.6685C6.89822 4.6685 6.00244 5.56429 6.00244 6.66929C6.00244 7.7743 6.89822 8.67008 8.00323 8.67008Z",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_708_1632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0063,
    height: 16.0063,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.92bd0c2074320e98dd8f0a48e92ecc44.svg";
export { ForwardRef as ReactComponent };